import { parseNum } from "./bookings-data";

export const columnsCommissionRules = [
	{
		name: 'Nombre',
		selector: (row) => row.id,
		cell: (row) => `${row.id} | ${row.name}`,
		sortable: true,
	},
	{
		name: 'Alcance',
		selector: row => row.scope,
		cell: (row) => row.scope,
		sortable: true,
		width: '100px'
	},
	{
		name: 'Activa',
		selector: (row) => row.active,
		cell: (row) => row.active === 1 ? 'SI' : 'NO',
		sortable: true,
		width: '100px'
	},
	{
		name: '€ Comisionados',
		selector: (row) => row.commissionAmount,
		cell: (row) => <strong>{parseNum('EUR', row.commissionAmount)}</strong>,
		sortable: true,
		width: '100px'
	},
	{
		name: '% Comisionado',
		selector: (row) => row.commissionPercent,
		cell: (row) => <strong>{parseNum('percent', row.commissionPercent)}</strong>,
		sortable: true,
		width: '100px'
	},
]

export const defaultFixCommissionRuleConditions = {
	origin: {
		8: [0, 0],
		9: [0, 0],
		10: [0, 0],
		17: [0, 0],
		19: [0, 0],
		22: [0, 0],
		23: [0, 0],
		3039: [0, 0],
		3044: [0, 0],
		3087: [0, 0],
		5013: [0, 0],
		5017: [0, 0],
	},
	creationDay: {
		0: [0, 0],
		1: [0, 0],
		2: [0, 0],
		3: [0, 0],
		4: [0, 0],
		5: [0, 0],
		6: [0, 0],
	},
	venue: {
		1: [0, 0],
		2: [0, 0],
	},
	shift: {
		1: [0, 0],
		2: [0, 0],
	},
	eventShift: {
		1: [0, 0],
		2: [0, 0],
		3: [0, 0],
		4: [0, 0],
		5: [0, 0],
		6: [0, 0],
		7: [0, 0],
		8: [0, 0],
		13: [0, 0],
		14: [0, 0],
		16: [0, 0],
		17: [0, 0],
		19: [0, 0],
	}
}
export const fixCommissionInputTranslations = {
	origin: {
		8: "Postas",
		9: "Mayor",
		10: "Toledo",
		17: "Ciudad Rodrigo",
		19: "Puerta 1911",
		22: "San Ginés",
		23: "San Jerónimo",
		3039: "Carretas",
		3044: "Espoz y Mina",
		3087: "Cádiz",
		5013: "Congreso",
		5017: "Sol",
	},
	creationDay: {
		1: "Lunes",
		2: "Martes",
		3: "Miércoles",
		4: "Jueves",
		5: "Viernes",
		6: "Sábado",
		0: "Domingo",
	},
	venue: {
		1: "Cardamomo",
		2: "1911"
	},
	shift: {
		1: "Mañana",
		2: "Tarde",
	},
	eventShift: {
		1: "18:00 cardamomo",
		2: "19:30 cardamomo",
		3: "21:00 cardamomo",
		4: "22:30 cardamomo",
		5: "18:00 1911",
		6: "19:30 1911",
		7: "21:00 1911",
		8: "22:30 1911",
		13: "Clases 1911",
		14: "23:40 1911",
		16: "MICE 1911",
		17: "MICE cardamomo",
		19: "23:40 cardamomo",
	}
}